module.exports = __webpack_public_path__ + "static/assets/a5f5538be9142e8bed53b7c7b1e558c0.png";